import { BLOCK_TABLE, BLOCK_TABLE_PRE, BLOCK_TABLE_SUF, BLOCK_TABLE_WRAP } from '../types';
import { getEmptyTableRow } from './get-empty-table-row';

import { MAX_TABLE_COLS, MAX_TABLE_ROWS } from '../TableElement'

export const getEmptyTable = (row, col) => ({
  type: BLOCK_TABLE_WRAP,
  isNew: true,
  children: [
    // {
    //   type: BLOCK_TABLE_PRE,
    //   children: [{ type: 'p', children: [{text: ''}] }]
    // },
    {
      type: BLOCK_TABLE,
      row:  Math.min(row, MAX_TABLE_ROWS),
      col: Math.min(col, MAX_TABLE_COLS),
      children: Array(Math.min(row, MAX_TABLE_ROWS))
        .fill('')
        .map(() => getEmptyTableRow(Math.min(col, MAX_TABLE_COLS))),
    },
    // {
    //   type: BLOCK_TABLE_SUF,
    //   children: [{text: ''}]
    // }
  ]
});